module.exports = __webpack_public_path__ + "static/media/buy_report_service_1.a083a92c.png";